module.exports = __webpack_public_path__ + "img/decorate.5d170448.svg";